<div class="events-wrapper" (click)="onPlayerClick()" data-testid="player_surface">
    @if (isPlaying()) {
    <rounded-icon-button class="control relative animate-icon" [size]="'large'"
        [imgSrc]="skinning?.getImage('icon_play')" [readonly]="true"></rounded-icon-button>
    } @else {
    <rounded-icon-button class="control relative animate-icon" [size]="'large'"
        [imgSrc]="skinning?.getImage('icon_pause')" [readonly]="true"></rounded-icon-button>
    }
</div>